import { jwtDecode } from 'jwt-decode';
import logger from './logger';

export const handleKeycloakEvent = (event, error, keycloak, setUserSession) => {
  const { token } = keycloak;
  if (!token) {
    logger.error('No token found');
    return;
  }

  const decoded = jwtDecode(token);
  const roles = decoded?.resource_access?.smartshield?.roles?.[0];

  const fullname = decoded.name;
  const { email } = decoded;
  const fetchData = (fakeDataUrl) => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      fetch(fakeDataUrl, {
        headers: { Authorization: `Bearer ${keycloak.token}` },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          logger.debug('Fetched data:', data);
        })
        .catch((error) => {
          logger.error('Error fetching data:', error);
        });
    }
  };
  if (event === 'onAuthSuccess') {
    fetchData(`${window.REACT_APP_API_PURE}user/logged`);
    setUserSession(keycloak.token, keycloak.refreshToken, email, roles, fullname);
    if (!roles || roles === 'undefined') {
      sessionStorage.clear();
      sessionStorage.setItem('token', 'gada');
      sessionStorage.setItem('role', 'norole');
    } else {
      // Store successful authentication timestamp
      sessionStorage.setItem('authSuccessTime', Date.now().toString());
    }
  } else if (event === 'onAuthError') {
    logger.error('Authentication error', error);
    // Clear any stored redirect path on auth error
    sessionStorage.removeItem('redirectAfterLogin');
  }
};
